import { getReservedWebsimUrl } from "@websim/core/src/utils/reserved-url";
import { parentApi } from "./message-proxy";

export function hijackEvents() {
  // Send pointer down events to the parent
  document.addEventListener("pointerdown", () => {
    // Only needed when in an iframe, not in top level frame
    if (!__WEBSIM_DATA__.isTopLevelFrame) {
      parentApi.iframeInteraction();
    }
  });

  const handleLinkClick = (event: MouseEvent) => {
    let target = event.target;
    if (!target) return;
    const closest = (target as HTMLElement)?.closest("a");
    if (closest) {
      target = closest;
    }
    if (target instanceof HTMLAnchorElement) {
      const href = target.getAttribute("href") || "";

      if (/^javascript:/i.test(href)) {
        return;
      }
      if (/^blob:/i.test(href)) {
        return;
      }
      if (/^data:/i.test(href)) {
        return;
      }

      const isNewTab =
        event.button === 1 || // middle clicks
        event.metaKey ||
        event.ctrlKey || // and command clicks
        target.target === "_blank";

      const isInternalLink = getReservedWebsimUrl(href);

      if (isInternalLink && !__WEBSIM_DATA__.isTopLevelFrame) {
        event.preventDefault();
        parentApi.navigate({
          method: "GET",
          url: href,
          target: isNewTab ? "_blank" : undefined,
          source: "link",
        });
      }
    }
  };

  // Intercept click events
  window.addEventListener("auxclick", (event) => {
    if (event.which !== 2) return;
    handleLinkClick(event);
  });

  window.addEventListener("click", (event) => {
    const target = event.target;

    if (event.defaultPrevented) {
      return;
    }

    // Handle logout and login buttons
    if (target instanceof HTMLButtonElement) {
      if (target.id === "google-login-button") {
        event.preventDefault();
        parentApi.login();
        return;
      }
    }

    handleLinkClick(event);
  });

  // Register a listener for CMD+L to focus the URL bar
  window.addEventListener("keydown", (event) => {
    if (event.defaultPrevented) {
      return;
    }

    if (event.key === "k" && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      parentApi.focusUrl();
    }
  });

  // Keep track of the most recent title to avoid sending duplicate messages
  let currentTitle = "";
  const setTitle = (title: string) => {
    if (title !== currentTitle) {
      currentTitle = title;
      parentApi.setTitle(title);
    }
  };

  // Update the title every second. This is a hack since I can't get
  // MutationObserver to detect changes to `document.title`.
  window.setInterval(() => setTitle(document.title), 1000);
}
